/*
Groups can be nested deeper than one level (a Group & Randomise block inside a
distributor group for example), so the edge flow is resolved until a flow that
is not a group is found.
*/
const getGroupEdgeFlow = (content, group, fromTheEnd, visitedGroupIds) => {
  if (!group || !group.flows || !group.flows.length) {
    return null;
  }

  const flowId = fromTheEnd
    ? group.flows[group.flows.length - 1]
    : group.flows[0];
  const childGroup = content.groups.find(cG => cG.id === flowId);

  if (!childGroup || visitedGroupIds.indexOf(childGroup.id) > -1) {
    return flowId;
  }

  return getGroupEdgeFlow(content, childGroup, fromTheEnd, [
    ...visitedGroupIds,
    group.id
  ]);
};

// Returns flow id
export const getGroupFirstFlow = (content, group) =>
  getGroupEdgeFlow(content, group, false, []);

// Returns flow id
export const getGroupLastFlow = (content, group) =>
  getGroupEdgeFlow(content, group, true, []);
